// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../breakpoints.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/icons/embedded.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/icons/not-embedded.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_graphTip__sjT49 {
    font-weight: 300;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    --tip-em-width: 109px;
}

.styles_graphTip__sjT49:before {
    content: '';
    display: block;
    margin-right: 17px;
    width: 12px;
    min-width: 12px;
    height: 12px;
    box-sizing: border-box;
}

.styles_graphTip__sjT49.styles_initial__c8tRw:before {
    background: var(--primary-color);
}

.styles_graphTip__sjT49.styles_nav__bAgG9:before {
    border: 1px solid var(--primary-color);
}

.styles_graphTip__sjT49.styles_taxed__7sVMl:before {
    border: 1px solid var(--secondary-color);
}

.styles_graphTip__sjT49.styles_embedded__IHSlu:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.styles_graphTip__sjT49.styles_notEmbedded__vIqW0:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.styles_graphTip__sjT49.styles_embedded__IHSlu:before,
.styles_graphTip__sjT49.styles_notEmbedded__vIqW0:before {
    width: var(--tip-em-width);
    min-width: var(--tip-em-width);
    background-position: center right 0;
    background-repeat: no-repeat;
    height: 12px;
}

.styles_graphTip__sjT49.styles_notEmbedded__vIqW0:before {
    background-size: 100% auto;
    height: 30px;
}

.styles_graphTip__sjT49.styles_embedded__IHSlu,
.styles_graphTip__sjT49.styles_notEmbedded__vIqW0 {
    /*white-space: nowrap;*/
}

/*@media screen-md-max {*/
/*.graphTip {*/
/*    width: 200px;*/
/*}*/

.styles_graphTip__sjT49.styles_embedded__IHSlu,
.styles_graphTip__sjT49.styles_notEmbedded__vIqW0 {
    /*width: 300px;*/
    margin-left: -96px;
}
/*}*/
`, "",{"version":3,"sources":["webpack://./src/pages/DealTaxes/components/DealTaxesTips/styles.module.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;IAEnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;IACI,yDAA2D;AAC/D;;AAEA;;IAEI,0BAA0B;IAC1B,8BAA8B;IAC9B,mCAAmC;IACnC,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB,cAAc;AACd,oBAAoB;AACpB,IAAI;;AAEJ;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;AACA,IAAI","sourcesContent":["@value screen-md-max from '../../../../breakpoints.css';\n\n.graphTip {\n    font-weight: 300;\n    display: flex;\n    align-items: center;\n    margin-bottom: 24px;\n\n    --tip-em-width: 109px;\n}\n\n.graphTip:before {\n    content: '';\n    display: block;\n    margin-right: 17px;\n    width: 12px;\n    min-width: 12px;\n    height: 12px;\n    box-sizing: border-box;\n}\n\n.graphTip.initial:before {\n    background: var(--primary-color);\n}\n\n.graphTip.nav:before {\n    border: 1px solid var(--primary-color);\n}\n\n.graphTip.taxed:before {\n    border: 1px solid var(--secondary-color);\n}\n\n.graphTip.embedded:before {\n    background-image: url('/src/assets/icons/embedded.svg');\n}\n\n.graphTip.notEmbedded:before {\n    background-image: url('/src/assets/icons/not-embedded.svg');\n}\n\n.graphTip.embedded:before,\n.graphTip.notEmbedded:before {\n    width: var(--tip-em-width);\n    min-width: var(--tip-em-width);\n    background-position: center right 0;\n    background-repeat: no-repeat;\n    height: 12px;\n}\n\n.graphTip.notEmbedded:before {\n    background-size: 100% auto;\n    height: 30px;\n}\n\n.graphTip.embedded,\n.graphTip.notEmbedded {\n    /*white-space: nowrap;*/\n}\n\n/*@media screen-md-max {*/\n/*.graphTip {*/\n/*    width: 200px;*/\n/*}*/\n\n.graphTip.embedded,\n.graphTip.notEmbedded {\n    /*width: 300px;*/\n    margin-left: -96px;\n}\n/*}*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"graphTip": `styles_graphTip__sjT49`,
	"initial": `styles_initial__c8tRw`,
	"nav": `styles_nav__bAgG9`,
	"taxed": `styles_taxed__7sVMl`,
	"embedded": `styles_embedded__IHSlu`,
	"notEmbedded": `styles_notEmbedded__vIqW0`
};
export default ___CSS_LOADER_EXPORT___;
